export * from './Truncate';
//# sourceMappingURL=index.js.map